import { atom, selector } from 'recoil';
import { atom_tourState } from './tour.atom';

export interface SavedStopState {
	stopId: string;
	modalType: 'stopsCards' | 'bigStop' | null;
	timestamp: string;
}

// Selector that synchronously reads from localStorage based on current tour
// Returns either the saved stop object or null when none is available
const savedStopStateSelector = selector<SavedStopState | null>({
	key: 'SavedStopStateSelector',
	get: ({ get }) => {
		const tourState = get(atom_tourState);

		if (!tourState?.id) {
			// No tour yet - not checked
			return null;
		}

		try {
			const stopModalStateKey = `stop_modal_state_${tourState.id}`;
			const savedState = localStorage.getItem(stopModalStateKey);

			if (savedState) {
				const parsedState = JSON.parse(savedState);
				return parsedState;
			} else {
				// Checked and found nothing
				return null;
			}
		} catch (error) {
			console.error('[SavedStopStateSelector] Error loading saved stop state:', error);
			return null;
		}
	}
});


export const atom_savedStopState = atom<SavedStopState | null>({
	key: 'SavedStopState',
	default: savedStopStateSelector, // Uses selector for initial value
});
